import { render, staticRenderFns } from "./ExternalQualityDashboard.vue?vue&type=template&id=584d2b46"
import script from "./ExternalQualityDashboard.vue?vue&type=script&lang=js"
export * from "./ExternalQualityDashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard_style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports